import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { combineLatest, Observable, of } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';
import { AccountDispatcher, AccountStore } from '../store';
import { REFERRAL_QUERY_PARAMETER_KEY } from '../account.data';

@Injectable()
export class ReferralGuard implements CanActivate {
  constructor(
    private _accountStore: AccountStore,
    private _accountDispatchers: AccountDispatcher,
    private _router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const referralCode = route.queryParamMap.get(REFERRAL_QUERY_PARAMETER_KEY);

    if (!referralCode) {
      return of(true);
    }

    return combineLatest(
      this._accountStore.isRefererLoaded(),
      this._accountStore.getRefererError()
    ).pipe(
      tap(([isLoaded, error]) => {
        if (!isLoaded && !error) {
          this._accountDispatchers.fetchReferer(referralCode);
        }
      }),
      map(([isLoaded, error]) => {
        if (!isLoaded && !error) {
          return this._router.createUrlTree(['register']);
        }

        return isLoaded;
      }),
      filter((x) => !!x),
      take(1)
    );
  }
}
